import MarketingImage from '@/components/landing/MarketingImage';
import React from 'react';
const clinicalNutritionistImage = '/images/marketing/landing-who-is-it-for-clinical-nutritionist.webp';
const dietitiansImage = '/images/marketing/landing-who-is-it-for-dietitians.webp';
const fitnessCoachImage = '/images/marketing/landing-who-is-it-for-fitness-coach.webp';
const nutritionEducatorsImage = '/images/marketing/landing-who-is-it-for-nutrition-educators.webp';
import styles from './TargetAudience.module.css';

const audienceCards = [
  {
    label: 'Nutrition Educators',
    image: nutritionEducatorsImage,
    className: styles.educatorCard
  },
  {
    label: 'Clinical Nutritionists',
    image: clinicalNutritionistImage,
    className: styles.clinicalCard
  },
  {
    label: 'Dietitians',
    image: dietitiansImage,
    className: styles.dieticianCard
  },
  {
    label: 'Fitness Coaches',
    image: fitnessCoachImage,
    className: styles.fitnessCard
  }
];

const TargetAudience = () => {
  return (
    <section id="for-who" className={styles.section}>
      <div className={styles.canvas}>
        <h2 className={styles.title}>Who is it for?</h2>

        <div className={styles.audienceGrid} aria-label="Professional audiences">
          {audienceCards.map(card => (
            <article key={card.label} className={`${styles.audienceCard} ${card.className}`}>
              <MarketingImage loading="lazy" src={card.image} alt={card.label} className={styles.audienceImage} />
              <span className={styles.labelPill}>{card.label}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
